import { useEffect, useRef } from 'react';

export default function VoiceCommentary({ speed, position, totalPoints, enabled }) {
  const lastCommentaryTime = useRef(0);
  const lastSpeed = useRef(0);
  const synthesis = window.speechSynthesis;

  const speak = (text) => {
    if (!enabled || !synthesis) return;
    
    // Cancel any ongoing speech
    synthesis.cancel();
    
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.rate = 1.1; // Slightly faster for excitement
    utterance.pitch = 1.0;
    utterance.volume = 0.8;
    
    synthesis.speak(utterance);
  };

  useEffect(() => {
    if (!enabled) return;

    const now = Date.now();
    const timeSinceLastComment = now - lastCommentaryTime.current;
    
    // Only comment every 3 seconds to avoid spam
    if (timeSinceLastComment < 3000) return;

    const speedDiff = speed - lastSpeed.current;
    const progress = ((position / totalPoints) * 100).toFixed(0);

    // Speed-based commentary
    if (speed > 180) {
      speak("Blazing fast! Maximum velocity!");
      lastCommentaryTime.current = now;
    } else if (speed > 150 && speedDiff > 20) {
      speak("Great acceleration through the corner!");
      lastCommentaryTime.current = now;
    } else if (speed < 50 && lastSpeed.current > 100) {
      speak("Heavy braking! Watch that ghost!");
      lastCommentaryTime.current = now;
    } else if (speed > 120 && Math.random() > 0.7) {
      const comments = [
        `Smooth driving at ${Math.round(speed)} kilometers per hour`,
        "Maintaining good speed through the sector",
        `${progress} percent complete, keep pushing!`,
        "The ghost is watching your every move"
      ];
      speak(comments[Math.floor(Math.random() * comments.length)]);
      lastCommentaryTime.current = now;
    }

    lastSpeed.current = speed;
  }, [speed, position, totalPoints, enabled]);

  return null; // This component doesn't render anything
}
